/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Page_H1Inputs */

const en_serve_page_h1 = /** @type {(inputs: Serve_Page_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build on your own computer, with the AI you already pay for`)
};

const id_serve_page_h1 = /** @type {(inputs: Serve_Page_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bangun di komputermu sendiri, dengan AI yang sudah kamu bayar`)
};

/**
* | output |
* | --- |
* | "Build on your own computer, with the AI you already pay for" |
*
* @param {Serve_Page_H1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_page_h1 = /** @type {((inputs?: Serve_Page_H1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Page_H1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_page_h1(inputs)
	return en_serve_page_h1(inputs)
});